import React from 'react';

function TestimonialCard({ name, role, content, avatar }) {
  return (
    <div className="group p-6 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm h-full transition-all duration-300 hover:border-white/20 hover:bg-white/10 relative overflow-hidden">
      {/* Hover Gradient Effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#C334F6]/5 to-[#543DF4]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      
      {/* Content */}
      <div className="relative z-10">
        <p className="mb-6 text-white/90 text-base leading-relaxed group-hover:text-white transition-colors duration-300">
          "{content}"
        </p>
        
        <div className="flex items-center space-x-4">
          <div className="relative group-hover:scale-105 transition-transform duration-300">
            <div className="absolute inset-0 bg-gradient-to-r from-[#C334F6] to-[#543DF4] rounded-full blur-lg opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
            <img 
              src={avatar} 
              alt={name} 
              className="w-12 h-12 rounded-full border-2 border-white/10 group-hover:border-white/20 transition-all duration-300"
              loading="lazy"
              width={48}
              height={48}
            />
          </div>
          
          <div>
            <h4 className="font-medium text-base text-white">
              {name}
            </h4>
            <p className="text-white/70 text-sm mt-1 group-hover:text-white/90 transition-colors duration-300">
              {role}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(TestimonialCard);